import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

// eslint-disable-next-line @nx/enforce-module-boundaries
import { UIModule } from "@intocare/ui";

import { FormsDirectivesModule } from "../directives";
import { ParagraphComponent } from "./components/paragraph/paragraph.component";

@NgModule({
	imports: [
		CommonModule,
		UIModule,
		FormsDirectivesModule,
		ReactiveFormsModule.withConfig({ callSetDisabledState: "whenDisabledForLegacyCode" }),
	],
	declarations: [ParagraphComponent],
	exports: [ParagraphComponent],
})
export class ParagraphFormModule {}
